export default class ShowZonesControl {
  constructor(props) {
    this.terminalId = props.terminalId;
    this.id = "showZonesCustomControl";
    this.onZoneClicked = props.onZoneClicked;
    this.zipZoneSource = "zipZoneMapping";
    this.zipZoneLayer = "US_Zones";
    this.geoJson = props.geoJson;
  }

  updateProps = ({ terminalId, geoJson }) => {
    this.terminalId = terminalId;
    this.geoJson = geoJson;
    this._map.on("moveend", this.onMoveEnd); 
  }

  onMoveEnd = () => {
      this.hideLayer(); // Perform hide layer & update sourceafter any pending animation else moving map animation gets blocked
      this.updateSource();
      this._map.off("moveend", this.onMoveEnd);
  }

  hideLayer = () => {
    const layer = this._map.getLayer(this.zipZoneLayer);
    if (layer && layer.visibility === "visible") {
      this._map.setLayoutProperty(this.zipZoneLayer, "visibility", "none");
    }
  }

  onClick = (event) => {
    if (this.onZoneClicked && event.features[0].properties) {
      this.onZoneClicked({
        data: event.features[0].properties,
        position: event.lngLat,
      });
    }
  };
  styleCursor = () => {
    this._map.getCanvas().style.cursor = "pointer";
  };
  removeCursor = () => {
    this._map.getCanvas().style.cursor = "";
  };

  removeZipZoneLayer = () => {
    if(this._map.getLayer(this.zipZoneLayer)){
      this._map.removeLayer(this.zipZoneLayer)
    }
    if(this._map.getSource(this.zipZoneSource)){
      this._map.removeSource(this.zipZoneSource)
    }
  };

  updateSource = () => {
    if(!this.geoJson || Object.keys(this.geoJson).length === 0){
      console.warn("Zipzone geojson not found for terminal ", this.terminalId);
      return;
    }
    const source = this._map.getSource(this.zipZoneSource);   
    if(source){
      source.setData(this.geoJson);
    } else {
      const geoJsonData = {
        type: "geojson",
        data: this.geoJson
      };
      this._map.addSource(this.zipZoneSource, geoJsonData);
    }
  }

  onMapStyleLoaded = () => {
    if(!this.geoJson || Object.keys(this.geoJson).length === 0){
      console.warn("Zipzone geojson not found for terminal ", this.terminalId);
      return;
    }
    this.updateSource();
    // Add a layer to draw circles for each point in the data source
    this._map.addLayer({
      id: this.zipZoneLayer,
      type: "fill",
      layout: { visibility: "none" },
      source: this.zipZoneSource,
      paint: {
        "fill-color": [
          "case",
          ["match", ["get", "AREA"], "", false, true],
          ["get", "COLOR"],
          ["get", "COLOR"],
        ],
        "fill-opacity": 0.2,
      },
    });
  };

  handleButtonClick = () => {
    if (!this._map.getLayer(this.zipZoneLayer)) {
      this.onMapStyleLoaded();
    }

    const zonesLayer = this._map.getLayer(this.zipZoneLayer);
    if (zonesLayer) {
     
      this._map.setFilter(zonesLayer.id, ['==', 'TERM', this.terminalId])
      this._map.setLayoutProperty(zonesLayer.id, "visibility", zonesLayer.visibility==="visible"?"none":"visible");

      if (zonesLayer.visibility === "visible") {
        this._map.on("click", this.zipZoneLayer, this.onClick);
        this._map.on("mouseenter", this.zipZoneLayer, this.styleCursor);
        this._map.on("mouseleave", this.zipZoneLayer, this.removeCursor);
      } else {
        this._map.off("click", this.zipZoneLayer, this.onClick);
        this._map.off("mouseenter", this.zipZoneLayer, this.styleCursor);
        this._map.off("mouseleave", this.zipZoneLayer, this.removeCursor);
      }
    }
  }
  onAdd(map) {
    this._map = map;
    this._map?.on("load", this.onMapStyleLoaded);
    this._container = document.createElement("div");
    this._container.className =
      "trimblemaps-ctrl trimblemaps-ctrl-group showZones";

    this.buttonControl = document.createElement("button");
    this.buttonControl.className = "trimblemaps-ctrl-icon icon-showZones";
    this.buttonControl.title = "Show/Hide Zones";
    this.buttonControl.textContent = "";
    this.buttonControl.ariaLabel = "Show/Hide Zones";
    this.buttonControl.addEventListener('click', this.handleButtonClick);
    this._container.append(this.buttonControl);
    return this._container;
  }
  onRemove() {
    this.removeZipZoneLayer();
    if(this.buttonControl){
      this.buttonControl.removeEventListener('click', this.handleButtonClick);
    }
    this._container.parentNode.removeChild(this._container);
    this._map.off("click", "US_Zones", this.onClick);
    this._map.off("mouseenter", "US_Zones", this.styleCursor);
    this._map.off("mouseleave", "US_Zones", this.removeCursor);
    this._map?.off("load", this.onMapStyleLoaded);
    this._container = undefined;
    this.buttonControl = undefined;
    this._map = undefined;
  }
}
